const tabButtons = document.querySelectorAll('.tab-button');
const tabContents = document.querySelectorAll('.tab-content');

tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.getAttribute('data-tab');
      const isActive = button.classList.contains('active');
      var screenWidth = window.innerWidth;
      
      if (isActive && screenWidth >= 769) return;

      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
  
      if (!isActive) {
        button.classList.add('active');
        document.getElementById(tabId).classList.add('active');
        scrollIntoViewCentered(button)
      }
    });
});

function scrollIntoViewCentered(element) {
    // Scroll the element into view
    element.scrollIntoView({ behavior: 'smooth' });
  
    // Calculate the center position of the container
    const container = element.parentElement;
    const containerCenter = container.clientHeight / 2;
  
    // Calculate the position of the element within the container
    const elementRect = element.getBoundingClientRect();
    const elementCenter = elementRect.top + elementRect.height;
  
    // Calculate the scroll offset needed to center the element
    const scrollOffset = elementCenter - containerCenter;
  
    // Scroll the container by the calculated offset
    container.scrollTo({ top: container.scrollTop + scrollOffset, behavior: 'smooth' });
  }

// Function to move tab content based on screen size
function rearrangeTabContent() {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) {
        // Move each tab content below its corresponding tab button
        const tabButtons = document.querySelectorAll('.tab-button');
        tabButtons.forEach(button => {
            const tabId = button.getAttribute('data-tab');
            const tabContent = document.querySelector(`.tab-content#${tabId}`);
            if (tabContent) {
                button.insertAdjacentElement('afterend', tabContent);
            }
        });
    } else {
        // Move tab contents to their default state only if window was resized
        const tabsContainer = document.querySelector('.tabs-wrapper');
        const tabContents = document.querySelectorAll('.tab-content');
        tabContents.forEach(content => {
            tabsContainer.insertAdjacentElement('beforeend',content);
        });
    }
}
if (window.innerWidth <= 768) {
    // Initial rearrangement on page load
    rearrangeTabContent();
}

// Set the resized flag to false
rearrangeTabContent.resized = false;

// Event listener for window resize
window.addEventListener('resize', () => {
        rearrangeTabContent.resized = true;
        rearrangeTabContent();
});